import { Controller } from "@hotwired/stimulus";

// Manages state-aware CTAs on the anonymous try page.
// Uses element IDs rather than Stimulus targets since the
// relevant elements span multiple non-nested DOM sections.
export default class extends Controller {
  connect() {
    this.requestCount = 0;
    this.tunnelActive = false;

    this._readInitialState();
    this._observeRequestCount();
    this._observeTunnelStatus();
    this._applyState();
  }

  disconnect() {
    this._requestObserver?.disconnect();
    this._tunnelObserver?.disconnect();
  }

  _readInitialState() {
    const countEl = document.getElementById("request-count-value");
    if (countEl) {
      this.requestCount = parseInt(countEl.dataset.count, 10) || 0;
    }

    const tunnelEl = document.getElementById("tunnel-status");
    if (tunnelEl) {
      this.tunnelActive = tunnelEl.dataset.tunnelActive === "true";
    }
  }

  _observeRequestCount() {
    const frame = document.getElementById("recent-requests");
    if (!frame) return;

    this._requestObserver = new MutationObserver(() => {
      const countEl = frame.querySelector("#request-count-value");
      if (countEl) {
        const newCount = parseInt(countEl.dataset.count, 10) || 0;
        if (newCount !== this.requestCount) {
          this.requestCount = newCount;
          this._applyState();
        }
      }
    });

    this._requestObserver.observe(frame, { childList: true, subtree: true });
  }

  _observeTunnelStatus() {
    const tunnelEl = document.getElementById("tunnel-status");
    if (!tunnelEl) return;

    this._tunnelObserver = new MutationObserver(() => {
      const el = document.getElementById("tunnel-status");
      if (!el) return;
      const newState = el.dataset.tunnelActive === "true";
      if (newState !== this.tunnelActive) {
        this.tunnelActive = newState;
        this._applyState();
      }
    });

    this._tunnelObserver.observe(tunnelEl, {
      attributes: true,
      attributeFilter: ["data-tunnel-active"],
      childList: true,
      subtree: true,
    });
  }

  _applyState() {
    const hasRequests = this.requestCount > 0;

    this._toggle("try-cta-pre-request", !hasRequests);
    this._toggle("try-cta-post-request", hasRequests);
    this._toggle("try-session-banner", hasRequests || this.tunnelActive);
    this._toggle("try-cta-default-message", !this.tunnelActive);
    this._toggle("try-cta-tunnel-message", this.tunnelActive);

    const countEl = document.getElementById("try-cta-request-count");
    if (countEl) {
      countEl.textContent = this.requestCount;
    }
  }

  _toggle(id, show) {
    const el = document.getElementById(id);
    if (el) {
      el.classList.toggle("hidden", !show);
    }
  }
}
